import React from 'react';
import { Badge, HStack, Icon, Text } from '@chakra-ui/react';
import { LuLock } from 'react-icons/lu';

const LOCKED_BADGE_LABEL = 'Pro';

interface PropertySelectorRowStatusProps {
	isLocked: boolean;
	badge?: string;
	colorPalette?: string;
}

const PropertySelectorRowStatus: React.FC<PropertySelectorRowStatusProps> = (props) => {
	const { isLocked, badge, colorPalette } = props;

	// TODO: for Shared rows, surface the viewer's access duration/expiry here as a badge
	// (user_role.expires_at — see getAccessExpiresAt / GuestAccessIndicator), with a priority
	// rule against the lock/Pro and Transferring badges so they don't collide.

	if (isLocked) {
		return (
			<Badge colorPalette="brand" variant="subtle" rounded="full" flexShrink={0}>
				<HStack gap={1}>
					<Icon as={LuLock} boxSize={3.5} />
					<Text as="span">{LOCKED_BADGE_LABEL}</Text>
				</HStack>
			</Badge>
		);
	}

	if (badge && colorPalette) {
		return (
			<Badge colorPalette={colorPalette} variant="subtle" rounded="full" flexShrink={0}>
				{badge}
			</Badge>
		);
	}

	return null;
};

export default PropertySelectorRowStatus;
